export default function initHero() {
  const playButton = document.querySelector(".hero__play-button");
  const overlay = document.getElementById("videoOverlay");
  const closeButton = document.querySelector(".hero__overlay-close");
  const videoContainer = document.getElementById("videoContainer");

  if (playButton) {
    playButton.addEventListener("click", function () {
      const videoUrl = playButton.getAttribute("data-video");

      if (videoUrl) {
        console.log("Video URL:", videoUrl);

        let videoId = "";

        // Convert "youtu.be/xyz" to "youtube.com/embed/xyz"
        if (videoUrl.includes("youtu.be")) {
          videoId = videoUrl.split("youtu.be/")[1]; // Extract ID
        } else if (videoUrl.includes("watch?v=")) {
          videoId = new URL(videoUrl).searchParams.get("v"); // Extract ID
        }

        if (videoId) {
          const youtubeEmbedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
          console.log("Embedding YouTube video:", youtubeEmbedUrl);

          videoContainer.innerHTML = `
            <iframe width="100%" height="100%" src="${youtubeEmbedUrl}"
            frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
          `;

          overlay.classList.add("show");
        }
      }
    });
  }

  if (closeButton) {
    closeButton.addEventListener("click", function () {
      console.log("Close button clicked!");
      overlay.classList.remove("show");
      videoContainer.innerHTML = ""; // Stop the video
    });
  }

  // Close overlay when clicking outside the video
  overlay.addEventListener("click", function (event) {
    if (event.target === overlay) {
      overlay.classList.remove("show");
      videoContainer.innerHTML = "";
    }
  });
}
